// src/hooks/useTrackingPage.ts
import { useLocation } from 'react-router-dom'

export const useTrackingPage = () => {
  const { pathname } = useLocation()

  const rawPath = window.location.pathname
  const form = rawPath.split('/')[1] ?? ''

  const GREENP_TRACKING_PAGE = ['mkt01']
  const isGreenpTracking = GREENP_TRACKING_PAGE.includes(form)

  return { form, isGreenpTracking, rawPath, rrPath: pathname }
}
